import { Controller } from "@hotwired/stimulus"

// Dynamic journal entry lines with a live running total.
// Submit stays disabled until debits === credits and both are > 0 —
// the server re-validates regardless (Accounting::JournalEntryCreator).
export default class extends Controller {
  static targets = ["lines", "template", "debitTotal", "creditTotal", "difference", "submit"]

  connect() {
    this.recalculate()
  }

  addLine(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_INDEX", Date.now().toString())
    this.linesTarget.insertAdjacentHTML("beforeend", html)
    this.recalculate()
  }

  removeLine(event) {
    event.preventDefault()
    if (this.lineElements().length <= 2) return
    event.target.closest("[data-journal-form-line]").remove()
    this.recalculate()
  }

  recalculate() {
    const debits = this.sum("[data-debit]")
    const credits = this.sum("[data-credit]")
    const balanced = debits > 0 && debits === credits

    this.debitTotalTarget.textContent = this.format(debits)
    this.creditTotalTarget.textContent = this.format(credits)
    this.submitTarget.disabled = !balanced

    this.differenceTarget.textContent = balanced
      ? "Balanced"
      : `Out of balance by ${this.format(Math.abs(debits - credits))}`
    this.differenceTarget.classList.toggle("text-green-700", balanced)
    this.differenceTarget.classList.toggle("text-red-700", !balanced)
  }

  blockImbalanced(event) {
    if (this.submitTarget.disabled) event.preventDefault()
  }

  // --- helpers ---

  lineElements() {
    return this.linesTarget.querySelectorAll("[data-journal-form-line]")
  }

  // Sums in integer fils to avoid floating-point drift.
  sum(selector) {
    return Array.from(this.linesTarget.querySelectorAll(selector)).reduce((total, input) => {
      const value = parseFloat(input.value.replaceAll(",", ""))
      return total + (Number.isFinite(value) ? Math.round(value * 100) : 0)
    }, 0)
  }

  format(fils) {
    return (fils / 100).toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
}
